import React from 'react';
import { Instagram, Facebook, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-light py-[100px] px-8" data-id="element-50">
      <div className="max-w-7xl mx-auto" data-id="element-51">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-52">
          {/* Column 1: Brand */}
          <div className="flex flex-col" data-id="element-53">
            <div className="font-optima font-semibold text-[24px] tracking-[0.15em] uppercase text-charcoal mb-2" data-id="element-54">
              Glenlofty
            </div>
            <div className="font-optima text-[16px] text-charcoal/60" data-id="element-55">
              Pyrenees, Victoria
            </div>
          </div>

          {/* Column 2: Explore */}
          <div data-id="element-56">
            <h3 className="font-optima font-semibold text-[14px] uppercase tracking-[0.12em] text-charcoal mb-6" data-id="element-57">
              Explore
            </h3>
            <ul className="flex flex-col gap-3" data-id="element-58">
              {['About Us', 'Our Wines', 'Sustainability', 'Contact'].map(item => <li key={item} data-id="element-59">
                    <a href="#" className="font-optima text-[16px] text-charcoal/80 hover:text-gold transition-colors" data-id="element-60">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>

          {/* Column 3: Wine Ranges */}
          <div data-id="element-61">
            <h3 className="font-optima font-semibold text-[14px] uppercase tracking-[0.12em] text-charcoal mb-6" data-id="element-62">
              Wine Ranges
            </h3>
            <ul className="flex flex-col gap-3" data-id="element-63">
              {['GO Range', 'Estate Reserve', 'Single Block'].map(item => <li key={item} data-id="element-64">
                  <a href="#" className="font-optima text-[16px] text-charcoal/80 hover:text-gold transition-colors" data-id="element-65">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 4: Connect */}
          <div data-id="element-66">
            <h3 className="font-optima font-semibold text-[14px] uppercase tracking-[0.12em] text-charcoal mb-6" data-id="element-67">
              Connect
            </h3>
            <div className="flex flex-col gap-4 mb-6" data-id="element-68">
              <div className="flex items-start gap-3 text-charcoal/80" data-id="element-69">
                <MapPin size={18} className="mt-1 flex-shrink-0" data-id="element-70" />
                <span className="font-optima text-[16px]" data-id="element-71">
                  123 Glenlofty-Warrenmang Road,
                  <br data-id="element-72" />
                  Glenlofty, VIC 3469
                </span>
              </div>
              <div className="flex items-center gap-3 text-charcoal/80" data-id="element-73">
                <Phone size={18} data-id="element-74" />
                <span className="font-optima text-[16px]" data-id="element-75">(03) 5354 8228</span>
              </div>
              <div className="flex items-center gap-3 text-charcoal/80" data-id="element-76">
                <Mail size={18} data-id="element-77" />
                <span className="font-optima text-[16px]" data-id="element-78">
                  hello@glenloftywines.com.au
                </span>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-79">
              <a href="#" className="text-charcoal hover:text-gold transition-colors" data-id="element-80">
                <Instagram size={20} data-id="element-81" />
              </a>
              <a href="#" className="text-charcoal hover:text-gold transition-colors" data-id="element-82">
                <Facebook size={20} data-id="element-83" />
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gold/20 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-84">
          <div className="flex gap-6" data-id="element-85">
            {['Privacy Policy', 'Terms & Conditions', 'Disclaimer'].map(item => <a key={item} href="#" className="font-optima text-[14px] text-charcoal/50 hover:text-charcoal transition-colors" data-id="element-86">
                  {item}
                </a>)}
          </div>
          <div className="font-optima text-[14px] text-charcoal/50" data-id="element-87">
            © 2026 Glenlofty Estate. All rights reserved.
          </div>
        </div>

        {/* Liquor License */}
        <div className="mt-6 text-center font-optima text-[13px] text-charcoal/50 max-w-3xl mx-auto" data-id="element-88">
          Liquor Licence No. 36148170. It is against the law to sell or supply
          alcohol to, or to obtain alcohol on behalf of, a person under the age
          of 18 years.
        </div>
      </div>
    </footer>;
}